var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ul',{staticClass:"centerx"},_vm._l((_vm.options),function(item,index){return _c('li',{key:index},[_c('vs-radio',{attrs:{"vs-value":item},model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}},[_vm._v(_vm._s(item))]),_vm._v("    ")],1)}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }